import { useRef, useState, useEffect } from "react";
import { faCheck, faTimes, faInfoCircle, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration2.css";
import axios from "../api/axios";
import { Link, useNavigate, useLocation } from "react-router-dom";

const MOBILE_REGEX = /^[0-9]{10}$/;
const OTP_REGEX = /^[0-9]{4}$/;
const PASSWORD_REGEX = /^.{6,}$/;
const GET_OTP_URL = "get-email-otp";
const REGISTER_URL = "user-signup";


const Get_email_otp = () => {
  const back = async (e) => {
    e.preventDefault();
    // setSuccess(false);
    setMobile("");
    setOtp("");
    setPassword("");
  };
  const userRef = useRef();
  const errRef = useRef();
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [cnfPassword, setCnfPassword] = useState("");

  const [validMobile, setValidMobile] = useState(false);
  const [validOtp, setValidOtp] = useState(false);
  const [validPassword, setValidPassword] = useState(false);
  const [validCnfPassword, setValidCnfPassword] = useState(false);

  const [mobileFocus, setMobileFocus] = useState(false);
  const [otpFocus, setOtpFocus] = useState(false);
  const [passwordFocus, setPasswordFocus] = useState(false);
  const [CnfPasswordFocus, setCnfPasswordFocus] = useState(false);

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");
  // const [success, setSuccess] = useState(false);

  useEffect(() => {
    userRef.current.focus();
  }, []);


  useEffect(() => {
    setValidMobile(MOBILE_REGEX.test(mobile));
  }, [mobile]);

  useEffect(() => {
    setValidOtp(OTP_REGEX.test(otp));
  }, [otp]);

  useEffect(() => {
    setValidPassword(PASSWORD_REGEX.test(password));
  }, [password]);

  useEffect(() => {
    setValidCnfPassword(PASSWORD_REGEX.test(cnfPassword));
  }, [cnfPassword]);

  const handleGetOtp = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.get(GET_OTP_URL, {
        params: { mobile },
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      setMobile(""); // clear input
    } catch (err) {
      if (!err?.response) {
        showMessage('error', "No Server Response");
      } else if (err.response?.status === 409) {
        showMessage('error', err.response?.data?.message);
      } else {
        showMessage('error', err.response?.data?.message || "Registration Failed!");
      }
      errRef.current.focus();
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    // if button enabled with JS hack

    try {
      var data = JSON.stringify({
        mobile,
        otp,
        password,
      });

      const response = await axios.post(REGISTER_URL, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
      showMessage('success', response?.data?.message);

    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        // Always show the exact API message
        setErrMsg(err.response.data.message);
      } else {
        setErrMsg("Registration Failed");
      }
      errRef.current.focus();
    }


  };
  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // ensure success message is cleared
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // ensure error message is cleared
    }

    // Auto-hide after 10 seconds
    setTimeout(() => {
      setErrMsg("");
      setSucssMsg("");
    }, 10000); // 10000ms = 10 seconds
  };



  return (
    <>
      <Container>
        {/* {success ? (
          <section>
            <h1>User successfully registred !</h1>
            <div className="flexGrow">
              <button onClick={back}>Back</button>
            </div>
          </section>
        ) : ( */}


        <section className="userregbody">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <p
            ref={errRef}
            className={sucssMsg ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {sucssMsg}
          </p>

          <div className="wrapper wrapper2">
            <form>
              <h3 className="arthik_head">Sign Up</h3>

              <div className="input-box arthik_input-box">
                <input
                  type="text"
                  id="mobile"
                  placeholder="Enter Mobile number"
                  autoComplete="off"
                  ref={userRef}
                  onChange={(e) => setMobile(e.target.value)}
                  value={mobile}
                  required
                  aria-invalid={validMobile ? "false" : "true"}
                  aria-describedby="namenote"
                  onFocus={() => setMobileFocus(true)}
                  onBlur={() => setMobileFocus(false)}
                />
                {/* <i className="bx bxs-user"></i> */}
                <p
                  id="namenote"
                  className={
                    mobileFocus && mobile && !validMobile ? "instructions" : "offscreen"
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                  Mobile number is required!.
                </p>
              </div>

              {mobile && (
                <button
                  type="button"
                  className="btn"
                  onClick={handleGetOtp}
                  disabled={!validMobile}
                >
                  Get OTP
                </button>
              )}

              <div className="input-box arthik_input-box">
                <input
                  type="text"
                  id="otp"
                  placeholder="Enter OTP"
                  autoComplete="off"
                  onChange={(e) => setOtp(e.target.value)}
                  value={otp}
                  required
                  aria-invalid={validOtp ? "false" : "true"}
                  aria-describedby="otpnote"
                  onFocus={() => setOtpFocus(true)}
                  onBlur={() => setOtpFocus(false)}
                />
                {/* <i className="bx bxs-user"></i> */}
                <p
                  id="otpnote"
                  className={
                    otpFocus && otp && !validOtp ? "instructions" : "offscreen"
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                  OTP is required!.
                </p>
              </div>

              <div className="input-box arthik_input-box">
                <input
                  type="password"
                  id="password"
                  placeholder="Enter Password"
                  autoComplete="off"
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  required
                  aria-invalid={validPassword ? "false" : "true"}
                  aria-describedby="passwordnote"
                  onFocus={() => setPasswordFocus(true)}
                  onBlur={() => setPasswordFocus(false)}
                />
                {/* <i className="bx bxs-user"></i> */}
                <p
                  id="passwordnote"
                  className={
                    passwordFocus && password && !validPassword ? "instructions" : "offscreen"
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                  Password is required!.
                </p>
              </div>

              <div className="input-box arthik_input-box">
                <input
                  type="password"
                  id="cnfPassword"
                  placeholder="Enter Conf. Password"
                  autoComplete="off"
                  onChange={(e) => setCnfPassword(e.target.value)}
                  value={cnfPassword}
                  required
                  aria-invalid={validCnfPassword ? "false" : "true"}
                  aria-describedby="cnfPasswordnote"
                  onFocus={() => setCnfPasswordFocus(true)}
                  onBlur={() => setCnfPasswordFocus(false)}
                />
                {/* <i className="bx bxs-user"></i> */}
                <p
                  id="cnfPasswordnote"
                  className={
                    CnfPasswordFocus && cnfPassword && !validCnfPassword ? "instructions" : "offscreen"
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                  Cnf. Password is required!.
                </p>
              </div>

              <button
                type="button" // Important to prevent form submit
                className="btn arthik_btn"
                onClick={handleSubmit} // Call this for "Sign Up"
                disabled={
                  !validMobile ||
                  !validOtp ||
                  !validPassword ||
                  !validCnfPassword ||
                  password !== cnfPassword}
              >
                Sign Up
              </button>
            </form>
            <p className="arthik_reg">Already Have an Account ? <Link to="/login" className="arthik_a"> Login</Link></p>

          </div>
        </section>
        {/* )} */}
      </Container>
    </>
  );
};

export default Get_email_otp;
